/**
 * Dear fellow developers,
 * don't waste your time on this component,
 * it doesn't matter, it works. Fuck the browser compatibility.
 * Just move on and actually make a difference on whatever you are going to do.
 */

import React, { PureComponent } from 'react';
import styles from './BitBackground.css';
import { generate } from 'shortid';
import { variables } from '../../../config/postcss.config';

// requestAnimationFrame polyfill
{
  const requestAnimationFrame = window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    window.setTimeout; // fallback to setTimeout
  window.requestAnimationFrame = requestAnimationFrame;
}

class BitBackground extends PureComponent {
  state = {
    isOver: false,
  };

  constructor(props) {
    super(props);

    this.gradientID = generate();
    this.maskID = generate();
    this.patternID = generate();
  }

  handleMouseMove = (e) => {
    // You Might Not Need jQuery (We Don't)
    const offset = this.background.getBoundingClientRect();
    const x = e.pageX - (offset.left + document.body.scrollLeft);
    const y = e.pageY - (offset.top + document.body.scrollTop);

    if (this.state.isOver) {
      window.requestAnimationFrame(() => {
        this.mask.setAttribute('cx', x);
        this.mask.setAttribute('cy', y);
      });
    }
  }

  handleMouseOver = (e) => {
    // only available on desktop
    if (window.innerWidth > variables.variables.mobile) {
      this.setState({
        isOver: true,
      });
    }
  }

  handleMouseLeave = (e) => {
    this.setState({
      isOver: false,
    });
  }

  backgroundRefCallback = (ref) => {
    this.background = ref;
  }

  maskRefCallback = (ref) => {
    this.mask = ref;
  }

  background = null;
  mask = null;

  render() {
    const { isOver } = this.state;
    const { isLighter, className, ...props } = this.props;
    const color = '#fced95';

    return (
      <div
        onMouseMove={this.handleMouseMove}
        onMouseOver={this.handleMouseOver}
        onMouseLeave={this.handleMouseLeave}
        ref={this.backgroundRefCallback}
        {...props}
        className={`${styles.bitBackground} ${className} ${isLighter ? styles.isLighter : ''}`}
      >
        <svg width="100%" height="100%">
          <defs>
            <radialGradient id={this.gradientID}>
              <stop offset="30%" stopColor="#FFF" stopOpacity="1" />
              <stop offset="100%" stopColor="#FFF" stopOpacity="0.3" />
            </radialGradient>
            <mask id={this.maskID}>
              <circle ref={this.maskRefCallback} r="150" fill={`url(#${this.gradientID})`} />
            </mask>
            <pattern id={this.patternID} x="0" y="0" patternUnits="userSpaceOnUse" height="40" width="40">
              <circle fill={color} opacity="1" r="2" cx="25" cy="25" />
            </pattern>
          </defs>

          <rect
            opacity={isOver ? 1 : 0}
            width="100%"
            height="100%"
            fill={`url(#${this.patternID})`}
            mask={`url(#${this.maskID})`}
          />
        </svg>
      </div>
    );
  }
}

export default BitBackground;



// WEBPACK FOOTER //
// ./src/components/BitBackground/index.js